import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type StarFilledProps = {
    className?: string;
};

const StarFilled: FunctionComponent<StarFilledProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'star-filled'}
            viewBox="0 0 250 250"
        >
            <polygon points="125 207.3 47.7 250 62.5 159.5 0 95.5 86.4 82.3 125 0 163.6 82.3 250 95.5 187.5 159.5 202.3 250" />
        </svg>
    );
};
export default StarFilled;
